import React from 'react';
import PropTypes from 'prop-types';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import { ButtonWithIcon } from '@els/els-react--button';

import './TooManySessionsModal.scss';

function TooManySessionsModal({ close }) {
  return (
    <DialogsWithIcon
      size="sm"
      movable={false}
      className="react-dialogs-scrollable too-many-sessions-modal"
      headerClassName="too-many-sessions-modal__header"
      contentClassName="too-many-sessions-modal__content"
      layoutType="info"
      character="i"
      closeBtn={false}
      header={
        <div className="too-many-sessions-modal__header_text">
          We have detected too many concurrent authentication requests from this workstation. Please wait 30 seconds and then try again.
        </div>
      }>
      <ButtonWithIcon type="primary" sprite="ChevronRight" iconRight onClick={close} className="e2e-forgot-password-close">
        Close
      </ButtonWithIcon>
    </DialogsWithIcon>
  );
}
TooManySessionsModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default TooManySessionsModal;
